<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaSubtipuri')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaNivel3')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                                <i class="fas fa-search"></i>
                            </span>
                    </div>
                    <button type="button" class="template-button" @click="$router.push('/subtypes/create')" v-if="$can(['create nivel3'])">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaNivel3')}}
                    </button>
                </div>
            </div>
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}} "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.mobileSorting" v-model="sortMobile.sortMobileBy" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Sorteaza dupa:">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType" v-model="sortMobile.sortMobileType" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Criteriu sortare:">
                </v-select>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('id')"> {{$t('tableHeader.id')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'id' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'id' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('Ord')" class="mobilehidden_header"> {{$t('tableHeader.ord')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'Ord' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'Ord' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('categ')"> {{$t('tableHeader.nivel1')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'categ' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'categ' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('subcateg')"> {{$t('tableHeader.nivel2')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'subcateg' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'subcateg' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('type')"> {{$t('tableHeader.denumire')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'type' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'type' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('addition')" class="mobilehidden_header"> {{$t('tableHeader.adaosComercial')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'addition' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'addition' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('discount')" class="mobilehidden_header"> {{$t('tableHeader.discount')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'discount' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'discount' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>

                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="level3">
                <tr v-for="(third, index) in level3" :key="index">
                    <td :tableheadData="$t('tableHeader.id')"> {{(third.id) ? third.id: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.ord')" class="mobilehidden_header"> {{(third.ord) ? third.ord: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.nivel1')"> {{(third.nivel1 && third.nivel1.name) ? third.nivel1.name: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.nivel2')"> {{(third.nivel2 && third.nivel2.name) ? third.nivel2.name: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.denumire')"> {{(third.name) ? third.name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.adaosComercial')" class="mobilehidden_header"> {{(third.addition) ? third.addition: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.discount')" class="mobilehidden_header"> {{(third.discount) ? third.discount: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.denumire')" class="options-case">
                        <router-link :to="{ name: 'viewsubtype', params: { id: third.id }}" class="view-user" v-if="$can(['view nivel3'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link :to="{ name: 'editsubtype', params: { id: third.id }}" class="edit-user" v-if="$can(['update nivel3'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['delete nivel3'])"
                           :title="$t('placeholder.sterge')" @click="removeLevel3(index, third.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="level3">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.id')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.ord')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.nivel1')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.nivel2')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.denumire')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.adaosComercial')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.discount')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="level3">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Level3Service from '../../api-services/nivel3.service.js'
export default {
  name: 'subtypes',
  data () {
    return {
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      mobileSorting: [
        { key: 'name', name: 'Nume' },
        { key: 'addition', name: 'Adaos' },
        { key: 'discount', name: 'Discount' },
        { key: 'subcateg', name: 'Subcategorie' },
        { key: 'categ', name: 'Categorie' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      level3: null,
      filters: {
        per_page: 25
      },
      search: '',
      searchBy: this.$route.query.q || null,
      showFilters: (this.$route.query.f_county && this.$route.query.f_county > 0) || (this.$route.query.f_city && this.$route.query.f_city > 0),
      meta: {}
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getLevel3()
    }
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.key : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },
    // return third page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return this.meta.current_page - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return this.meta.current_page + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    getLevel3 () {
      this.level3 = null
      this.$store.dispatch('showLoading')
      Level3Service.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.level3 = response.data.data
          } else {
            this.level3 = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'subtypes', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.mobileSorting.find(function (element) {
            return element.key === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    },
    filterUsers () {
      if (this.filters.county && this.filters.city) {
        this.applyQuery({ f_county: this.filters.county.id, f_city: this.filters.city.id })
      } else if (this.filters.county) {
        // let newRouteQuery = _.omit(this.$route.query, 'f_city')
        // this.$router.replace( { query: newRouteQuery } )
        this.applyQuery({ f_county: this.filters.county.id, f_city: 0 })
      } else {
        this.applyQuery({ f_county: 0, f_city: 0 })
      }
      this.showFilters = false
    },
    resetFilters () {
      this.filters.city = null
      this.filters.county = null
      this.applyQuery({ f_county: 0, f_city: 0, page: 1 })
      this.showFilters = false
    },
    removeLevel3 (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeNivel3'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          Level3Service.delete(id)
            .then((response) => {
              this.$delete(this.level3, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  created () {
    let query = this.$route.query
    if (query.q) this.search = query.q
    this.getLevel3()
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
  }
}
</script>
